<template>
  <div id="statusBar" ref="statusBar" class="relative flex flex-col h-full font-semibold">
    <div class="relative flex flex-grow p-4 overflow-scroll" style="height: 76%">
      <!-- eslint-disable -->
      <div class="self-center flex-grow h-full text-base sm:pr-12 mission v:text-4xl sm:text-2xl">
        <PerfectScrollbar class="h-full">
          <div v-if="GET_PLAY_STATUS > 0" v-html="message"></div>
          <div v-else>안녕하세요! 여러분의 학습 도우미 <span class="text-white">키키</span>이에요 ! </div>
        </PerfectScrollbar>
      </div>
      <div class="self-end flex-none mission-padding"></div>
    </div>
    <!--end::description-->

    <div id="progressBar" class="relative flex-none mr-16 overflow-hidden" style="height: 24%">
      <div class="flex h-full mb-4 overflow-hidden bg">
        <div
          :style="{ width: GET_PERCENT + '%' }"
          class="flex flex-col justify-center text-xs font-bold text-center text-white shadow-none whitespace-nowrap fill sm:text-base v:text-3xl"
        >
          진행 {{ GET_PERCENT }}%
        </div>
      </div>
      <button
        v-if="isShowHelp"
        class="absolute top-0 flex items-center justify-center block w-full h-full text-sm font-bold text-white bg-gray-900 v:text-4xl sm:text-xl"
        @click.stop="assist"
      >
        도움이 필요하면 저를 눌러 주세요
      </button>
    </div>
    <!--end::progressBar-->

    <img
      ref="characterRef"
      :src="character"
      :style="characterStyle"
      @click="assist"
      class="absolute bottom-0 right-0 z-10 cursor-pointer"
      alt="character"
    />
  </div>
</template>

<script>
import Vue from 'vue'
import * as _ from 'lodash'
import { authComputed } from '@state/helpers'
import { mapGetters } from 'vuex'
import { PLAYS } from '@state/modules/play'
import { ASSIST, EVENT, MODE, PLAY_STATUS } from '@src/games/constant'
import { GAMES } from '@state/modules/game'
import TTS from '@utils/browser-tts'
import { isFunction } from 'lodash'
import store from '@state/store'

export default {
  data() {
    return {
      tts: new TTS({ rate: 0.9 }),
      ttsTimeout: null,
      curScene: null,
      message: '',
      gameMode: {},
      isShowHelp: true,
      character: '@assets/images/statusbar/char-1.svg',
      characterStyle: {
        height: 0,
      },
    }
  },
  computed: {
    ...authComputed,
    ...mapGetters(GAMES.NAME, [GAMES.GET_GAME_MODES]),
    ...mapGetters(PLAYS.NAME, [PLAYS.GET_PLAY_MODE, PLAYS.GET_PLAY_STATUS, PLAYS.GET_PLAY_MODE, PLAYS.GET_PERCENT]),
  },
  beforeMount() {
    this.$events.on(EVENT.STATUSBAR_CHANGE_TEXT, this.changeText)
    this.$events.on(EVENT.PLAY_SCENE_ACTIVE, this.activeScene)
    this.$events.on(EVENT.PLAY_STATUS_START, this.playTTS)

    // change character image per game mode
    switch (this.GET_PLAY_MODE) {
      case MODE.BEGINNER:
        this.character = require('@assets/images/statusbar/char-1.svg')
        break
      case MODE.INTERMEDIATE:
        this.character = require('@assets/images/statusbar/char-2.svg')
        break
      case MODE.ADVANCED:
        this.character = require('@assets/images/statusbar/char-3.svg')
        break
      default:
        this.character = require('@assets/images/statusbar/char-1.svg')
    }

    // initialize
    this.gameMode = this.GET_GAME_MODES[this.GET_PLAY_MODE]
    this.message = this.gameMode.mission
  },
  beforeDestroy() {
    this.$events.off(EVENT.PLAY_SCENE_ACTIVE, this.activeScene)
    this.$events.off(EVENT.STATUSBAR_CHANGE_TEXT, this.changeText)
    this.$events.off(EVENT.PLAY_STATUS_START, this.playTTS)
    this.tts.stop()
  },
  mounted() {
    this.matchHeight()
  },
  methods: {
    assist() {
      this.$events.emit(ASSIST.SHOW, { scene: this.curScene, isForce: true })
    },
    activeScene({ index, scene, id }) {
      this.curScene = scene

      // if first scene, disable auto assist
      if (index > 0) {
        this.isShowHelp = false
      }

      // replace to the assist message
      const message = _.get(this.gameMode, `assistMessages.${id}`, this.message)
      this.message = isFunction(message) ? message(store) : message
      this.playTTS()
    },
    statusBarHeight() {
      return this.$refs.statusBar.clientHeight
    },
    matchHeight() {
      const charHeight = Number(this.statusBarHeight() + 15)
      Vue.set(this.characterStyle, 'height', charHeight + 'px')
    },
    changeText(customId) {
      const message = _.get(this.gameMode, `assistMessages.${customId}`, this.message)
      this.message = isFunction(message) ? message(store) : message
      this.playTTS()
    },
    playTTS() {
      if (this.GET_PLAY_MODE !== MODE.ADVANCED && this.GET_PLAY_STATUS === PLAY_STATUS.START) {
        this.tts.stop()
        clearTimeout(this.ttsTimeout)

        this.ttsTimeout = setTimeout(() => {
          const message = this.message.replaceAll(/([^가-힣|\d])/g, ' ')
          this.tts.play(message)
        }, 1500)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.mission-padding {
  width: 30%;
}

#statusBar {
  background-color: var(--color-bg);
  box-shadow: 0px -2px 10px 0px rgba(0, 0, 0, 0.4);

  .mission {
    color: #423c3d;
  }
}

#progressBar {
  border-top: 4px solid #433d3c;
  border-left: 4px solid #433d3c;
  border-bottom: 4px solid #433d3c;

  .fill {
    background-color: #433d3c;
    transition: all 0.5s;
  }

  .bg {
    background-color: white;
  }
}
</style>
